import { render, staticRenderFns } from "./MenuChooseBox.vue?vue&type=template&id=c986a192&scoped=true&"
import script from "./MenuChooseBox.vue?vue&type=script&lang=js&"
export * from "./MenuChooseBox.vue?vue&type=script&lang=js&"
import style0 from "./MenuChooseBox.vue?vue&type=style&index=0&id=c986a192&lang=scss&scoped=true&"
import style1 from "./MenuChooseBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c986a192",
  null
  
)

export default component.exports